import { useTranslation } from 'react-i18next';
import { useRef, useEffect } from 'react';

const ValueSection = ({ elementosweb, lang, destinos, ruta }) => {
    const { t } = useTranslation();

    const aleatorio = Math.floor(Math.random() * destinos.length);

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    return (
        <div className="mb-8 row">
            <div className="col-md-6">
                <figure className="o-cont-fullw not-xl-fullw o-cont-md-fullw__left not-xl-fullw__left mh-sm-240 ratio ratio-16x9">
                    <img src={`${ruta}/destinos/${destinos[aleatorio].id}/${destinos[aleatorio].imagen_principal[0].imagen}`} alt="" />
                    <figcaption className="fcover">{t("Vale Suites")}</figcaption>
                </figure>
            </div>
            <div className="col-md-6 d-flex flex-column justify-content-center align-items-center align-items-md-start">
                <h1 className="text-center text-md-start h1-lg-vw">{elementosweb.subtitulo_buscador[lang]}</h1>
                <div className="col-md-auto offset-sm-1 offset-md-2 offset-lg-3 offset-xl-4">
                    <p className="text-sm text-center text-md-start nolineheight">
                        <em className="nolineheight">
                            {elementosweb.subtitulo_propiedades[lang]}
                        </em>
                    </p>
                </div>
            </div>

            <div className="mt-3 mb-6 col-lg-9 offset-lg-3">
                <div className="c-swiper-cards_overflow">
                    <c-swiper-cards>
                        <div init="false" className="c-swiper-cards">
                            {
                                destinos.map((undestino, index) => (
                                    <swiper-slide style={{ width: "33%", marginRight: "16px" }} role="group" aria-label="1 / 3" className="swiper-slide-active" key={undestino.id || `destino-${index}`}>
                                        <div className="c-card basic">
                                            <figure className="c-card_img">
                                                {undestino.imagen_principal.length > 0 ?
                                                    <img className="img" src={`${ruta}/destinos/${undestino.id}/${undestino.imagen_principal[0].imagen}`} alt="" />
                                                    :
                                                    <img src="/images/web/bedloop-nofoto.png" alt="" />
                                                }

                                            </figure>
                                            <h3 className="c-card_title">{undestino.elnombre}</h3>

                                            <p className="nolineheight" dangerouslySetInnerHTML={{
                                                __html:
                                                    (undestino.ladesc.replace(/<[^>]*>/g, "").length > 100
                                                        ? undestino.ladesc.replace(/<[^>]*>/g, "").substring(0, 100) + "..."
                                                        : undestino.ladesc.replace(/<[^>]*>/g, ""))
                                            }}></p>

                                            <a tabIndex="0" className="mt-auto btn btn-link ps-0 fw-semibold" href={`/${preidioma}${t("buscar")}?destino=${undestino.laurl}`}> {t("VER APARTAMENTOS")} <div className="o-icon arrow">
                                                <i className="fa-solid fa-arrow-right"></i>
                                            </div>
                                            </a>

                                        </div>
                                    </swiper-slide>
                                ))
                            }
                        </div>
                    </c-swiper-cards>
                </div>
            </div>
        </div >
    );
}

export default ValueSection;
